// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"99":"bambuser-handler","506":"cart-handler","536":"list-handler","889":"purchase-middleware-app"}[chunkId] || chunkId) + "." + {"49":"7aa09d4c","99":"230100fd","506":"3ea5bdda","536":"cfb17539","889":"536462fa"}[chunkId] + ".js";
};